// api-denial.service.ts
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ApiDenial {
  code: 'forbidden_tier' | 'prod_writes_disabled' | 'feature_disabled' | 'not_in_ecase';
  detail: string;
}

/**
 * Carries API 403 denial reasons from BaseApiService to AppComponent, which
 * forwards them to NotificationService. No dependencies on purpose:
 * NotificationService -> PermissionsService -> UserService -> BaseApiService,
 * so BaseApiService cannot inject NotificationService directly.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiDenialService {
  private readonly denialSubject = new Subject<ApiDenial>();
  readonly denials$: Observable<ApiDenial> = this.denialSubject.asObservable();

  emit(d: ApiDenial): void {
    this.denialSubject.next(d);
  }
}
